import { Controller } from "@hotwired/stimulus"

// Opens/closes a native <dialog> referenced by CSS selector. showModal()
// provides backdrop, ESC-to-close, and focus trapping for free, and the
// trigger can live anywhere in the DOM (e.g. inside a dropdown menu).
export default class extends Controller {
  static values = { selector: String }

  open(event) {
    event.preventDefault()
    this.dialog?.showModal()
  }

  close(event) {
    event?.preventDefault()
    this.dialog?.close()
  }

  get dialog() {
    return document.querySelector(this.selectorValue)
  }
}
